import { render, staticRenderFns } from "./WitnessStatisticsListView.vue?vue&type=template&id=4b5d8b83&"
import script from "./WitnessStatisticsListView.vue?vue&type=script&lang=js&"
export * from "./WitnessStatisticsListView.vue?vue&type=script&lang=js&"
import style0 from "./WitnessStatisticsListView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports